import { motion } from "framer-motion";

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const LogoMark = ({ size = 34, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <circle cx="32" cy="32" r="20" stroke="#DC2626" strokeWidth="2.5" />
    <circle cx="32" cy="32" r="11" stroke="#DC2626" strokeWidth="1.5" opacity="0.6" />
    <line x1="32" y1="2" x2="32" y2="62" stroke="#DC2626" strokeWidth="2.5" />
    <line x1="2" y1="32" x2="62" y2="32" stroke="#DC2626" strokeWidth="2.5" />
    <circle cx="32" cy="32" r="4" fill="#DC2626" />
  </svg>
);

export const CornerTicks = ({ className = "border-red-600/70" }) => (
  <>
    <span className={`absolute top-0 left-0 h-4 w-4 border-t-2 border-l-2 ${className}`} />
    <span className={`absolute top-0 right-0 h-4 w-4 border-t-2 border-r-2 ${className}`} />
    <span className={`absolute bottom-0 left-0 h-4 w-4 border-b-2 border-l-2 ${className}`} />
    <span className={`absolute bottom-0 right-0 h-4 w-4 border-b-2 border-r-2 ${className}`} />
  </>
);

export const SectionHeading = ({ kicker, title, testId }) => (
  <motion.div
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
    className="mb-12 sm:mb-16"
  >
    <p className="font-mono-tech text-xs sm:text-sm tracking-[0.3em] text-red-500 uppercase mb-4 flex items-center gap-3">
      <span className="inline-block h-px w-10 bg-red-600" />
      {kicker}
    </p>
    <h2
      data-testid={testId}
      className="font-display text-5xl sm:text-6xl lg:text-7xl uppercase tracking-wide text-white leading-[0.95]"
    >
      {title}
    </h2>
  </motion.div>
);

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);
